import { getCompanyAISettings } from "../../services/defs/internal-api/ai";

export const companyAISettingsQuery = () => ({
	queryKey: ["ai", "settings"],
	queryFn: () => getCompanyAISettings(),
	meta: {
		errorMessage: "There was an error getting the company settings.",
	},
});
